export default __webpack_public_path__ + "static/media/manzil_showcase_1.webp";